import * as React from "react";
import { useEffect, useState } from "react";
import { useAuth } from "@airborne/react-admin";
import { Datagrid, ReferenceField, TextField, useDataProvider } from "react-admin";
import FilterToolbar from "../../../Components/FiltersToolbar/FilterToolbar";
import { DefaultPerPageSize } from "../../../Constants/Constant";
import { FilterInputType, FilterTypes } from "../../../Enums/FilterTypes";
import { ExcelExport } from "../../../Helper/ExportExcel";
import { CustomDateField } from "../../../Components/CustomDateField";
import { DetailButton } from "../../../Components/DetailButton";
import { SourceRequestOrder } from "../../../Pages/RequestOrder/Constant/Source";
import { makeStyles } from "@material-ui/core";
import ListActions from "./ListActions";
import PoolList from "../../../Components/PoolListComponent/PoolListComponent";
import CopyableTableWrapper from "../../../../src/Components/CopyableTableWrapper";
const useStyles = makeStyles({
  datagrid: {
    "& .MuiTableCell-root": {
      padding: "0px !important", // Hücreler arasındaki padding'i sıfırlar
      marginLeft: "0px !important",
      marginRight: "0px !important",
    },
    "& .MuiTableCell-head": {
      padding: "0px 2px 0px 2px !important", // Başlık hücreleri için padding'i sıfırlar
    },
    "& .MuiTableCell-body": {
      padding: "0px", // Gövde hücreleri için padding'i sıfırlar
    },
    "& .MuiTableCell-sizeSmall": {
      padding: "0px 2px 0px 2px !important", // Gövde hücreleri için padding'i sıfırlar
    },
  },
});
const RbhSearch = props => {
  const { user } = useAuth();
  const classes = useStyles();
  const dataProvider = useDataProvider();
  const [customers, setCustomers] = useState<any>();
  const [aircraftList, setAircraftList] = useState<any>();

  useEffect(() => {
    getCustomerData();
  }, []);

  const getCustomerData = async () => {
    await dataProvider
      .getList("cdmheaders", {
        pagination: { page: 1, perPage: 1000 },
        sort: { field: "customerCode", order: "ASC" },
        filter: {},
      })
      .then(response => {
        const customerCodes = [...new Set(response.data?.map(x => x.ownerName))];
        const customerData = customerCodes?.map(ownerName => ({ id: ownerName, customerCode: ownerName }));
        setCustomers(customerData);
        getAircraftListWithOwnerCode(customerData[0].customerCode);
      });
  };

  const getAircraftListWithOwnerCode = async (ownerCode: string) => {
    await dataProvider
      .getList("cdmaircraft/" + ownerCode, {
        pagination: { page: 1, perPage: 1000 },
        sort: { field: "id", order: "ASC" },
        filter: {},
      })
      .then(response => {
        setAircraftList(response?.data);
      });
  };

  const exporter = (records, fetchRelatedRecords) => {
    // will call dataProvider.getMany('cdmaircraft', { ids: records.map(record => record.aircraftId) }), ignoring duplicate and empty aircraftId
    fetchRelatedRecords(records, "aircraftId", "cdmaircraft").then(aircraft => {
      const data = records.map(record => ({
        //...record,
        "Customer Code": record.customerName,
        "Ref No": record.refNo,
        Category: record.category,
        Pn: record.pn,
        "Airport Code": record.airportCode,
        Ac: aircraft[record.aircraftId]?.acReg,
        "Customer Po": record.customerPo,
        "Request Date": record.requestDate,
        "Requested Delivery Date": record.requestedDeliveryDate,
        "Serviceable Forward Date": record.svcForwardDate,
        "Serviceable Estimated Delivery Date": record.svcEstimatedDeliveryDate,
        "Core Unit Forward Date": record.unsvcForwardDate,
        "Core Unit Estimated Delivery Date": record.unsvcEstimatedDeliveryDate,
        "Request Status": record.requestStatus,
        "Svc Pn": record.svcPn,
        "Svc Sn": record.svcSn,
        "Svc Awb": record.svcAwb,
        "Core Pn": record.unsvcPn,
        "Core Sn": record.unsvcSn,
        "Core Awb": record.unsvcAwb,
        Serviceable: record.serviceable,
        "Core Unit": record.unserviceable,
      }));

      const columns = Object.keys(data[0]).map(record => ({ header: record }));

      ExcelExport(columns, data, "Search List");
    });
  };

  const ownerHandleChange = e => {
    let ownerCode = e?.target?.value;
    getAircraftListWithOwnerCode(ownerCode);
  };

  return (
    <PoolList
      {...props}
      title={"Search"}
      hasCreate={false}
      exporter={exporter}
      resource="requestorders/search"
      basePath="search"
      bulkActionButtons={false}
      perPage={DefaultPerPageSize}
      actions={<ListActions {...props} />}
      filters={
        <FilterToolbar
          dataSource={[
            user?.isCustomer === false && {
              source: "ownerCode",
              inputType: FilterInputType.Select,
              label: "Customer",
              disabled: user?.isCustomer,
              filterTypeChangeDisable: true,
              filterType: FilterTypes.Equals,
              choices: customers,
              // defValue: customers?.[0]?.customerCode,
              optionValue: "id",
              optionText: "id",
              resettable: false,
              onChange: ownerHandleChange,
            },
            {
              source: "pn",
              inputType: FilterInputType.Text,
              label: "Pn",
            },
            {
              source: "refNo",
              inputType: FilterInputType.Text,
              label: "Ref No",
            },
            {
              source: "category",
              inputType: FilterInputType.Text,
              label: "Category",
            },
            {
              source: "requestStatus",
              inputType: FilterInputType.Text,
              label: "Request Status",
            },
            {
              source: "svcPn",
              inputType: FilterInputType.Text,
              label: "Svc Pn",
            },
            {
              source: "svcSn",
              inputType: FilterInputType.Text,
              label: "Svc Sn",
            },
            {
              source: "svcAwb",
              inputType: FilterInputType.Text,
              label: "Svc Awb",
            },
            {
              source: "unsvcPn",
              inputType: FilterInputType.Text,
              label: "Core PN",
            },
            {
              source: "unsvcSn",
              inputType: FilterInputType.Text,
              label: "Core SN",
            },
            {
              source: "unsvcAwb",
              inputType: FilterInputType.Text,
              label: "Core Awb",
            },
            {
              source: "aircraftId",
              inputType: FilterInputType.AutoComplete,
              label: "Aircraft",
              filterTypeChangeDisable: true,
              filterType: FilterTypes.Equals,
              choices: aircraftList,
              reference: "cdmaircraft",
              optionValue: "id",
              optionText: "acReg",
            },
            {
              source: "airportCode",
              inputType: FilterInputType.Text,
              label: "Airport Code",
            },
            {
              source: "customerPo",
              inputType: FilterInputType.Text,
              label: "Customer Po",
            },
            {
              source: "requestDate",
              inputType: FilterInputType.Date,
              label: "Request Date From",
              filterTypeChangeDisable: true,
              filterType: FilterTypes.GreaterThan,
            },
            {
              source: "requestDate",
              inputType: FilterInputType.Date,
              label: "Request Date To",
              filterTypeChangeDisable: true,
              filterType: FilterTypes.LessThan,
            },
            {
              source: "requestedDeliveryDate",
              inputType: FilterInputType.Date,
              label: "R.D.D. From",
              filterTypeChangeDisable: true,
              filterType: FilterTypes.GreaterThan,
            },
            {
              source: "requestedDeliveryDate",
              inputType: FilterInputType.Date,
              label: "R.D.D. To",
              filterTypeChangeDisable: true,
              filterType: FilterTypes.LessThan,
            },
            {
              source: "unsvcForwardDate",
              inputType: FilterInputType.Date,
              label: "Core Forward Date",
            },
            {
              source: "unsvcEstimatedDeliveryDate",
              inputType: FilterInputType.Date,
              label: "Core Estimated Delivery Date",
            },
            {
              source: "svcForwardDate",
              inputType: FilterInputType.Date,
              label: "Svc Forward Date",
            },
            {
              source: "svcEstimatedDeliveryDate",
              inputType: FilterInputType.Date,
              label: "Svc Estimated Delivery Date",
            },
          ]}
        />
      }
    >
      <CopyableTableWrapper>
        <Datagrid optimized classes={{ table: classes.datagrid }}>
          <DetailButton path={SourceRequestOrder} />
          <TextField source="customerName" label="Customer" />
          <TextField source="refNo" label="Ref No" />
          <TextField source="category" label="Category" />
          <TextField source="pn" label="Pn" />
          <TextField source="airportCode" label="AirportCode" />
          <ReferenceField label="Ac" source="aircraftId" reference="cdmaircraft" link={false}>
            <TextField source="acReg" />
          </ReferenceField>
          <TextField source="customerPo" label="Customer Po" />
          <CustomDateField source="svcForwardDate" label="Serviceable Forward Date" />
          <CustomDateField source="svcEstimatedDeliveryDate" label="Serviceable Estimated Delivery Date" />
          <CustomDateField source="unsvcForwardDate" label="Core Unit Forward Date" />
          <CustomDateField source="unsvcEstimatedDeliveryDate" label="Core Unit Estimated Delivery Date" />
          <CustomDateField source="requestDate" label="Request Date" />
          <CustomDateField source="requestedDeliveryDate" label="Requested Delivery Date" />
          <TextField source="requestStatus" label="Request Status" />
          <TextField source="svcPn" label="Svc Pn" />
          <TextField source="svcSn" label="Svc Sn" />
          <TextField source="svcAwb" label="Svc Awb" />
          <TextField source="unsvcPn" label="Core PN" />
          <TextField source="unsvcSn" label="Core SN" />
          <TextField source="unsvcAwb" label="Core Awb" />
          <TextField source="serviceable" label="Serviceable" />
          <TextField source="unserviceable" label="Core Unit" />
          <TextField source="requestType" label="Request Type" />
        </Datagrid>
      </CopyableTableWrapper>
    </PoolList>
  );
};

export default RbhSearch;
